import { theme } from 'Assets/Styles/theme'

const styles = {
  container: {
    textAlign: 'center',
    border: `1px solid ${theme.colors.iron}`,
    borderRadius: '4px',
    marginBottom: '16px',
    maxHeight: '600px',

    '&  p': {
      fontSize: '14px',
    },
  },

  tableHead: {
    background: '#F8F8F8',
  },

  stickyHeader: {
    position: 'sticky',
    top: '34px',
  },

  borderRight: {
    borderRight: `1px solid ${theme.colors.iron}`,
  },

  noDataWrapper: {
    height: '200px',
    border: `1px solid ${theme.colors.iron}`,
    borderRadius: '5px',
    margin: '16px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',

    '& > span': {
      cursor: 'pointer',
    },
  },

  noData: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    color: '#8A96A0',
    marginBottom: '16px',
  },

  uploadWrapper: {
    height: '200px',
    width: '100%',
    background: '#F8F8F8',
    border: `2px dashed ${theme.colors.iron}`,
    borderRadius: '5px',
    margin: '16px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
  },

  upload: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',

    '& > svg': {
      width: '20px',
    },
    '& > p': {
      fontSize: '26px',
    },
  },
  uploaded: {
    height: '200px',
    width: '100%',
    background: '#F8F8F8',
    border: `2px dashed ${theme.colors.iron}`,
    borderRadius: '5px',
    margin: '16px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > svg': {
      cursor: 'pointer',
      width: '20px',
    },
    '& > p': {
      fontSize: '16px',
    },
  },

  uploadBtn: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '8px',
  },

  mb16: {
    marginBottom: '16px',
  },

  underlined: {
    textDecoration: 'underline',
  },

  downloadTemplate: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.colors.primary,
  },

  fileValidationError: {
    fontSize: '14px',
    color: theme.colors.red,
    textAlign: 'center',
  },

  dmCostsUpdatedData: {
    fontFamily: 'Proxima Nova, sans-serif',
    fontSize: 14,
    color: '#707087',
  },

  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },

  actionButton: {
    cursor: 'pointer',
  },

  deleteModal: {
    top: '250px',
    width: '100%',
    height: 'auto',
  },

  printersModal: {
    '& .modal-content': {
      width: '668px',
    },
  },
}

export default styles
